import { render, staticRenderFns } from "./ShortVideoCard.vue?vue&type=template&id=2c6b9e5e&scoped=true"
import script from "./ShortVideoCard.vue?vue&type=script&lang=js"
export * from "./ShortVideoCard.vue?vue&type=script&lang=js"
import style0 from "./ShortVideoCard.vue?vue&type=style&index=0&id=2c6b9e5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6b9e5e",
  null
  
)

export default component.exports